


























































import {
  Component, Vue, PropSync, Prop,
} from 'vue-property-decorator';
import Overlay from '@/components/Overlay/index.vue';
import Textfield from '@/components/Form/Textfield/index.vue';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';
import TextButton from '@/components/Buttons/TextButton/index.vue';

@Component({
  components: {
    Overlay,
    Textfield,
    PrimaryButton,
    TextButton,
  },
})
export default class AcceptAvailability extends Vue {
  @PropSync('dialog', {}) dialogSync!: boolean;

  @PropSync('availabilityEvent', {}) eventSync!: any;

  @Prop({}) loading!: boolean;

  @Prop({}) status!: boolean;

  @Prop({}) unitName!: string;

  public close() {
    this.$emit('cancel');
  }

  public onAccept() {
    this.$emit('accept', this.eventSync);
  }
}
